import { getApiBase } from '../lib/apiBase';

export interface ClarityVariant {
  editedText: string;
  reasoning: string;
  error?: string;
}

export interface ParsedClarityExamples {
  genres: string[];
  examplesByGenre: Record<string, string[]>;
}

export function parseClarityExamples(input?: string | null): ParsedClarityExamples | null {
  if (!input || !input.trim()) {
    return null;
  }

  try {
    const parsed = JSON.parse(input);
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
      return null;
    }

    const examplesByGenre: Record<string, string[]> = {};
    Object.entries(parsed).forEach(([genre, value]) => {
      if (!Array.isArray(value)) {
        return;
      }

      const cleaned = value.filter(
        (item): item is string => typeof item === 'string' && item.trim().length > 0
      );

      if (cleaned.length > 0) {
        examplesByGenre[genre] = cleaned;
      }
    });

    const genres = Object.keys(examplesByGenre);
    return genres.length > 0 ? { genres, examplesByGenre } : null;
  } catch {
    return null;
  }
}

export async function requestClarityPreview(text: string, examples: string, genre?: string): Promise<ClarityVariant> {
  const response = await fetch(`${getApiBase()}/api/clarity/preview`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text, examples, genre })
  });

  if (!response.ok) {
    throw new Error('Failed to generate clarity edit.');
  }

  const data = await response.json();
  return {
    editedText: data.editedText || text,
    reasoning: data.reasoning || ''
  };
}
